// extracted by mini-css-extract-plugin
export default {"wrapper":"bIHw1","wrapper--disabled":"YXHI5","logo-img":"g89uF","title":"l0mUC","env":"es3TG"};